// @ngInject
function VersionService($rootScope,$timeout, $http, $window) {

    var currentPromise = null;
    var started = false;
    var checkInterval = 30 * 1000;

    var service = {
        start: start,
        stop: stop,
        hasVersionChanged: false,
        reload: reload,
        allowReloadOnStateChange: false
    };

    return service;

    function start() {
        if (service.hasVersionChanged) {
            return;
        }
        if (currentPromise) {
            $timeout.cancel(currentPromise);
        }
        started = true;
        currentPromise = $timeout(checkVersion, checkInterval);
    }

    function stop() {
        if (currentPromise) {
            started = false;
            $timeout.cancel(currentPromise);
        }
    }

    function reload() {
        $window.location.reload();
    }

    function checkVersion() {
        var url = 'version.json?nocache=' + (new Date()).getTime();
        $http.get(url)
        .then(function(response) {
            if (response.data.version !== '1.0.0') {
                console.log('version changed');
                service.hasVersionChanged = true;
                started = false;
                $rootScope.$emit('Version.Changed', response.data.version);
            }

            if (started) {
                currentPromise = $timeout(checkVersion, checkInterval);
            }
        });
    }
}

angular
    .module('app.version', [])
    .factory('VersionService', VersionService);
